import { InfoElementType, ObjectCardType } from "../types/types"
import { ReactComponent as RESTORE } from "../../../assets/RefreshICON.svg"
import { ReactComponent as MAPPIN } from "../../../assets/MapPinICON.svg"
import { ReactComponent as ARCHIVE } from "../../../assets/ArchiveICON.svg"
import { ReactComponent as UNARCHIVE } from "../../../assets/UnArchiveICON.svg"
import { ReactComponent as DELETE } from "../../../assets/DeleteICON.svg"
import { ReactComponent as OFFER } from "../../../assets/OfferIcon.svg"
import { ReactComponent as BILL } from "../../../assets/BillIcon.svg"
import BasePopover from "../../../components/elements/BasePopover"
import { P } from "../../../auth/permissions"
import { Authorized } from "../../../components/authentication/Authorized"

export default function ObjectCard(props: ObjectCardType) {
    return (
        <div
            className={`w-full max-h-64 h-fit rounded-default shadow-lg flex flex-col px-4 pt-4 pb-6 bg-white relative ${
                props.archived && "text-gray-400 opacity-60"
            }`}>
            {props.deleted && (
                <p className="absolute top-20 bottom-[50%] right-20 rotate-12 font-bold text-black/30 opacity-50 scale-150">Gelöscht</p>
            )}
            <h3 title={props.adress.street} className="border-b mb-4 pb-1 text-lg 2xl:text-xl font-semibold px-2 truncate">
                {props.objectDescription}
            </h3>
            <InfoElement info={props.costcenter?.name} icon={<MAPPIN className="w-6 h-6" />} />
            <InfoElement info={props.offers + " Angebote"} icon={<OFFER className="w-6 h-6" />} />
            <InfoElement info={props.bills + " gestellte Rechnungen"} icon={<BILL className="w-6 h-6" />} />

            <Authorized allOf={[P.objekte_read_write, P.objekte_delete]}>
                <div className="flex flex-row justify-end gap-2 grow items-center z-10">
                    <p title="Archivieren">
                        <BasePopover
                            label={props.archived ? "Archivieren Rückgängig machen?" : "Wirklich archivieren?"}
                            okButtonClick={props.archiveFunc}>
                            {props.archived ? <UNARCHIVE className="w-6 h-6 cursor-pointer" /> : <ARCHIVE className="w-6 h-6 cursor-pointer" />}
                        </BasePopover>
                    </p>
                    {!props.deleted ? (
                        <p title="Löschen" onClick={props.deleteFunc}>
                            <DELETE className="w-6 h-6 cursor-pointer hover:text-error" />
                        </p>
                    ) : (
                        <p title="Wiederherstellen" onClick={props.restoreFunc}>
                            <RESTORE className="w-6 h-6 cursor-pointer" />
                        </p>
                    )}
                </div>
            </Authorized>
            {/* CLICK ON CARD FOR OPEN */}
            <div onClick={props.openFunc} className="w-full h-full absolute top-0 left-0 cursor-pointer" />
        </div>
    )
}

function InfoElement({ info, icon }: InfoElementType) {
    return (
        <div className="flex flex-row pt-0.5 2xl:pt-1 pl-2">
            {icon}
            <p className="pl-2 text-sm 2xl:text-base">{info}</p>
        </div>
    )
}
